import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import enTranslations from "./locales/en.json";
import deTranslations from "./locales/de.json";
import faTranslations from "./locales/fa.json";

export const SUPPORTED_LOCALES = ["en", "de", "fa"] as const;
export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];

export const LOCALE_NAMES: Record<SupportedLocale, string> = {
	en: "English",
	de: "Deutsch",
	fa: "فارسی",
};

export const RTL_LOCALES: readonly SupportedLocale[] = ["fa"];

export function isRTL(locale: string): boolean {
	return RTL_LOCALES.includes(locale as SupportedLocale);
}

export function getDefaultLocale(): SupportedLocale {
	if (typeof window === "undefined") {
		return "en";
	}

	const stored = localStorage.getItem("hoopoe-locale");
	if (stored && SUPPORTED_LOCALES.includes(stored as SupportedLocale)) {
		return stored as SupportedLocale;
	}

	const browserLang = navigator.language.split("-")[0];
	if (SUPPORTED_LOCALES.includes(browserLang as SupportedLocale)) {
		return browserLang as SupportedLocale;
	}

	return "en";
}

i18n.use(initReactI18next).init({
	resources: {
		en: { translation: enTranslations },
		de: { translation: deTranslations },
		fa: { translation: faTranslations },
	},
	lng: getDefaultLocale(),
	fallbackLng: "en",
	interpolation: {
		escapeValue: false,
	},
});

export default i18n;
